import { render, staticRenderFns } from "./StudentsHeaderFilter.vue?vue&type=template&id=afaac9c6&scoped=true"
import script from "./StudentsHeaderFilter.vue?vue&type=script&lang=js"
export * from "./StudentsHeaderFilter.vue?vue&type=script&lang=js"
import style0 from "./StudentsHeaderFilter.vue?vue&type=style&index=0&id=afaac9c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afaac9c6",
  null
  
)

export default component.exports